import { render, staticRenderFns } from "./DashboardDepartment.vue?vue&type=template&id=0b317829&"
import script from "./DashboardDepartment.vue?vue&type=script&lang=js&"
export * from "./DashboardDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports